import React from 'react';
import { Body, Box, Heading, Stack } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import IntroCard from '../common/IntroCard';

const FPHero = () => (
  <Box
    position="relative"
    maxW={{ base: 'xl', desktop: '8xl' }}
    w="100%"
    d="block"
    mx="auto"
    py={{ base: '80px', desktop: '100px' }}
  >
    <Box ml="auto" borderRadius={10} overflow="hidden" maxW="840px">
      <StaticImage
        src="../../../assets/images/partners_featured_hero.jpg"
        alt=""
      />
    </Box>
    <IntroCard
      color="#96d700"
      logo={
        <StaticImage
          src="../../../assets/images/dabella_logo_stacked.png"
          alt="DaBella logo"
        />
      }
      description="DaBella is the recognized leader in home improvement services, building lasting value in roofing, siding, windows, and baths."
      top="40px"
      left="220px"
    >
      <Stack flexDir="row" justifyContent="space-evenly" textAlign="center">
        <Box d="block" maxW={150}>
          <Heading size={500} sx={{ mb: 0 }}>
            71%
          </Heading>
          <Body fontWeight={300}>branch locations expanded by</Body>
        </Box>
        <Box d="block" maxW={150}>
          <Heading size={500} sx={{ mb: 0 }}>
            10%
          </Heading>
          <Body fontWeight={300}>production hires only increased by</Body>
        </Box>
      </Stack>
    </IntroCard>
    <IntroCard
      color="#cb2d2f"
      logo={
        <StaticImage
          src="../../../assets/images/travelers_logo.svg"
          alt="Travelers logo"
        />
      }
      description="Travelers uses HOVER to increase the speed of home inspections, decrease resolution time, and increase the accuracy of its estimates for its carriers."
      top="470px"
      left="24px"
    />
    <IntroCard
      color="#1e407d"
      logo={
        <StaticImage
          src="../../../assets/images/crawford_logo.svg"
          alt="Crawford logo"
        />
      }
      description="Crawford uses HOVER to increase the speed of home inspections, decrease resolution time, and increase the accuracy of its estimates for its carriers."
      right="200px"
      bottom="-32px"
    />
  </Box>
);

export default FPHero;
